jQuery(document).ready(function($){
    $('.nf-slideshow-block').each(function(){
        const slideshow = $(this);
        const slider_nav = $(slideshow.nextAll('.nf-slideshow-block__slider-nav')[0]);
        const overlay = $(slideshow.nextAll('.nf-slideshow-block__overlay')[0]);

        slideshow.find('.nf-slideshow-block__slides').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            swipeToSlide: true,
            variableWidth: true,
            adaptiveHeight: false,
            appendArrows: slider_nav.find('.nf-slideshow-block__slider-nav__wrapper'),
            prevArrow: '<button class="nf-slideshow-block__slider-nav__prev"><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.46875 15.4375L9.8125 14.125L4.5625 8.875H21V7H4.5625L9.84375 1.71875L8.5 0.40625L0.96875 7.9375L8.46875 15.4375Z" fill="#D6E5FF"/></svg></button>',
            nextArrow: '<button class="nf-slideshow-block__slider-nav__next"><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5312 15.4375L11.1875 14.125L16.4375 8.875H0V7H16.4375L11.1562 1.71875L12.5 0.40625L20.0312 7.9375L12.5312 15.4375Z" fill="#D6E5FF"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        variableWidth: false,
                        infinite: true,
                        adaptiveHeight: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                        infinite: true,
                        adaptiveHeight: true
                    }
                }
            ]
        });
    
        overlay.find('.nf-slideshow-block__overlay__slides').slick({
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            appendArrows: overlay.find('.nf-slideshow-block__overlay__nav'),
            prevArrow: '<button class="nf-slideshow-block__slider-nav__prev"><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.46875 15.4375L9.8125 14.125L4.5625 8.875H21V7H4.5625L9.84375 1.71875L8.5 0.40625L0.96875 7.9375L8.46875 15.4375Z" fill="#D6E5FF"/></svg></button>',
            nextArrow: '<button class="nf-slideshow-block__slider-nav__next"><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5312 15.4375L11.1875 14.125L16.4375 8.875H0V7H16.4375L11.1562 1.71875L12.5 0.40625L20.0312 7.9375L12.5312 15.4375Z" fill="#D6E5FF"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true
                    }
                }
            ]
        });
    });

    $('.nf-slideshow-block__backdrop, .nf-slideshow-block__overlay__close').on('click', function(){
        $('.nf-slideshow-block__overlay').removeClass('active');
        $('.nf-slideshow-block__backdrop').hide();
        $('html').removeClass('nf-slideshow-active');
    });

    $('.nf-slideshow-block__slider-caption, .nf-slideshow-block__slide').on('click', function(){
        let overlay;

        if ( $(this).hasClass('nf-slideshow-block__slider-caption') ) {
            overlay = $(this).closest('.nf-slideshow-block__slider-nav').nextAll('.nf-slideshow-block__overlay')[0];
        }
        else {
            overlay = $(this).closest('.nf-slideshow-block').nextAll('.nf-slideshow-block__overlay')[0];
        }

        $(overlay).addClass('active');
        $('.nf-slideshow-block__backdrop').show();

        $('html').addClass('nf-slideshow-active');

        if ( ! $(this).hasClass('nf-slideshow-block__slider-caption') ) {
            const slide_to_scroll_to = $(this).closest('.slick-slide').data('slick-index');
            $(overlay).find('.nf-slideshow-block__overlay__slides').slick( 'slickGoTo', slide_to_scroll_to );
        }
    });
});